/**
 * 取込画面で選んだファイルが、受け付ける種類（input の accept と同じ ".csv,.xlsx" の形）かどうか。
 *
 * ファイルを選ぶ画面で「すべてのファイル」に切り替えると、accept 以外のファイルも選べてしまう。
 * それまでは「取込」を押してサーバーが読んだあとに「対象外のヘッダーが存在します」などが出ていたので、
 * 選んだ時点で拡張子を確かめる（受入テスト 2026-11-04、JCIKAIHATSU-496）。
 */
export function isAcceptedImportFile(file: File | null | undefined, accept: string): boolean {
  if (!file) return false;
  const name = file.name.toLowerCase();
  return accept
    .split(",")
    .map((ext) => ext.trim().toLowerCase())
    .filter((ext) => ext.length > 0)
    .some((ext) => name.endsWith(ext));
}
